import { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import {
  DetailsColumn,
  DetailsLabel,
  DetailsRow,
  DetailsText,
  TopBarContainedBrandButton,
  TopBarContainedCancelButton,
  TopBarContainer,
} from "../../../constants/component.constants";
import { GridActionsCellItem } from "@mui/x-data-grid";
import {
  Check,
  Clear,
  Delete,
  Edit,
  Visibility,
  PlayArrow,
  Pause,
  CalendarToday,
  LocationOn,
  Map,
} from "@mui/icons-material";
import { SuggestedDatesSelector } from "../listingView";
import {
  loadFacilityUnits,
  loadListingTypes,
  loadPropertyTypes,
  loadUserFacilities,
} from "../../../services/listingsServices/list.service";
import {
  formatCurrency,
  isEmptyArray,
  isEmptyString,
  isNullUndefined,
  titleCase,
  imageTypes
} from "../../../util/util";
import { setMessage, issueResponseMessage } from "../../../actions/message";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {
  deleteListing,
  getListingsByPersonId,
  reorderListingDocuments,
  saveListingData,
  toggleListingStatus,
  listAppointmentsForListing,
  processListingAppointment,
  saveAppointment,
  deleteListingDocument,
} from "../../../services/listingsServices/listing.service";
import { amber, green, red } from "@mui/material/colors";
import { DocumentStore } from "../../../components/documentStore";
import ConfirmationModal from "../../../components/modals/confirmation";
import {
  ResponsiveRow,
} from "../../../constants/layout.constants";
import {
  Chip,
  MenuItem,
  Paper,
  TextField,
  Typography,
  OutlinedInput,
  IconButton,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import FileUpload from "react-material-file-upload";
import { useDispatch, useSelector } from "react-redux";
import ModalContainerModule from "../../../components/modules/modalContainer";
import { GET_LISTING_IMAGE_URL } from "../../../constants/url.constants";
import LocationPickerModal from "../../../components/modals/listings/locationPickerModal";
import {
  issueWarnMessage,
  issueSuccessMessage,
} from "../../../actions/message";
import InputCharactersCountWrapper from "../../../components/inputs/inputCharactersCountWrapper";
import {
  DndContext,
  PointerSensor,
  TouchSensor,
  closestCenter,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  rectSortingStrategy,
  useSortable,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import MuiDataGrid from "../../../components/modules/MuiDataGrid";

function SortableImageItem({
  item,
  isPendingDeletion,
  onDelete,
  onRestore,
  onRemoveNew,
}) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: item.id });
  const previewUrl = item.type === "existing"
    ? `${GET_LISTING_IMAGE_URL}?filename=${item.systemFileName}`
    : URL.createObjectURL(item.file);
  return (
    <Box
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      sx={{
        position: "relative",
        width: 150,
        height: 150,
        borderRadius: "8px",
        overflow: "hidden",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        opacity: isPendingDeletion ? 0.5 : 1,
        border: isPendingDeletion ? "2px solid #f44336" : "1px solid #ddd",
        transition: transition || "all 0.2s ease",
        touchAction: "none",
        transform: CSS.Transform.toString(transform),
        zIndex: isDragging ? 10 : "auto",
        cursor: "grab",
        userSelect: "none",
      }}
    >
      <img
        src={previewUrl}
        alt={item.fileName}
        style={{ width: "100%", height: "100%", objectFit: "cover", pointerEvents: "none" }}
      />
      <Box
        sx={{
          position: "absolute",
          left: 6,
          top: 6,
          backgroundColor: "rgba(0,0,0,0.6)",
          color: "white",
          fontSize: "11px",
          padding: "2px 6px",
          borderRadius: "12px",
          pointerEvents: "none",
        }}
      >
        Drag
      </Box>
      {item.type === "existing" ? (
        isPendingDeletion ? (
          <IconButton
            size="small"
            onPointerDown={(e) => e.stopPropagation()}
            onClick={() => onRestore(item.documentId)}
            sx={{
              position: "absolute",
              top: 5,
              right: 5,
              backgroundColor: "rgba(76,175,80,0.9)",
            }}
          >
            <Check fontSize="small" color="success" />
          </IconButton>
        ) : (
          <IconButton
            size="small"
            onPointerDown={(e) => e.stopPropagation()}
            onClick={() => onDelete(item.documentId)}
            sx={{ position: "absolute", top: 5, right: 5, backgroundColor: "rgba(255,255,255,0.9)" }}
          >
            <Delete fontSize="small" color="error" />
          </IconButton>
        )
      ) : (
        <IconButton
          size="small"
          onPointerDown={(e) => e.stopPropagation()}
          onClick={() => onRemoveNew(item.id)}
          sx={{ position: "absolute", top: 5, right: 5, backgroundColor: "rgba(255,255,255,0.9)" }}
        >
          <Delete fontSize="small" color="error" />
        </IconButton>
      )}
      {isPendingDeletion && (
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            backgroundColor: "rgba(244,67,54,0.8)",
            color: "white",
            textAlign: "center",
            fontSize: "12px",
            padding: "4px",
          }}
        >
          Marked for deletion
        </Box>
      )}
    </Box>
  );
}

export default function ListingManagement() {
  const dispatch = useDispatch();
  const [listings, setListings] = useState([]);
  const [selectedListing, setSelectedListing] = useState(null);
  const [, setTotalListings] = useState(0);
  const [loading, setLoading] = useState(false);
  const [task, setTask] = useState("");
  const [listingForm, setListingForm] = useState(false);
  const [viewForm, setViewForm] = useState(false);
  const [propertyName, setPropertyName] = useState("");
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [selectedPropertyType, setSelectedPropertyType] = useState("");
  const [price, setPrice] = useState("");
  const [listingTypes, setListingTypes] = useState([]);
  const [selectedListingType, setSelectedListingType] = useState("");
  const [longitude, setLongitude] = useState("");
  const [latitude, setLatitude] = useState("");
  const [sqft, setSqft] = useState("");
  const [beds, setBeds] = useState("");
  const [baths, setBaths] = useState("");
  const [description, setDescription] = useState("");
  const [filterByPropertyName, setFilterByPropertyName] = useState("");
  const [filterByPropertyType, setFilterByPropertyType] = useState("");
  const [filterByListingType, setFilterByListingType] = useState("");
  const [files, setFiles] = useState([]);
  const [imageOrderItems, setImageOrderItems] = useState([]);
  const [pendingImageDeletions, setPendingImageDeletions] = useState([]); // Track images marked for deletion
  const [titleText, setTitleText] = useState("");
  const [severityText, setSeverityText] = useState("");
  const [bodyText, setBodyText] = useState("");
  const [positiveText, setPositiveText] = useState("");
  const [negativeText, setNegativeText] = useState("");
  const [deleteListingModal, setDeleteListingModal] = useState(false);
  const user = useSelector((state) => state.auth.user);
  const [unitExistsInSystem, setUnitExistsInSystem] = useState(false);
  const [userHasAdminRole, setUserHasAdminRole] = useState(false);
  const [userFacilities, setUserFacilities] = useState([]);
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [facilityUnits, setFacilityUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [, setSelectedUnitObject] = useState({});

  // Track the original unit/facility for the current edit session
  const [editSessionUnitId, setEditSessionUnitId] = useState(null);
  const [editSessionFacilityId, setEditSessionFacilityId] = useState(null);

  // Replace the separate modal states with a single toggle modal
  const [toggleListingModal, setToggleListingModal] = useState(false);

  // Add state variables for Tour Bookings table
  const [appointments, setAppointments] = useState([]);
  const [appointmentsLoading, setAppointmentsLoading] = useState(false);

  // Location picker state
  const [showLocationPicker, setShowLocationPicker] = useState(false);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);

  // Add state for draft confirmation modal
  const [draftConfirmationModal, setDraftConfirmationModal] = useState(false);

  // Add state variables for appointment actions
  const [appointmentConfirmType, setAppointmentConfirmType] = useState("");
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [appointmentReason, setAppointmentReason] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);
  const sensors = useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 6 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 120, tolerance: 8 } }),
  );

  useEffect(() => {
    loadListingTypes()
      .then((data) => setListingTypes(data))
      .catch((error) => {
        console.error("loadListingTypes Error: ", error);
      });
    loadPropertyTypes()
      .then((data) => setPropertyTypes(data))
      .catch((error) => {
        console.error("loadPropertyTypes Error: ", error);
      });
    loadUserFacilities()
      .then((data) => setUserFacilities(data))
      .catch((error) => {
        console.error("loadUserFacilities Error: ", error);
      });
  }, []);

  useEffect(() => {
    let roles = user.roles;
    if (
      roles.includes("BLDIR") ||
      roles.includes("BLDMG") ||
      roles.includes("CS")
    ) {
      setUserHasAdminRole(true);
    }
  }, [user.roles]);

  useEffect(() => {
    if (!selectedFacility) {
      setFacilityUnits([]);
      return;
    }

    // Include the original unit attached to the listing when Edit was opened,
    // but only for its original facility.
    let includeUnitId = null;
    if (
      editSessionUnitId &&
      (!editSessionFacilityId || editSessionFacilityId === selectedFacility)
    ) {
      includeUnitId = editSessionUnitId;
    }

    loadFacilityUnits(selectedFacility, includeUnitId)
      .then((data) => {
        if (!isEmptyArray(data)) {
          setFacilityUnits(data);
        } else {
          if (!isEmptyString(selectedFacility)) {
            dispatch(
              setMessage({
                type: "warning",
                message: "There are no available units for this facility!",
              }),
            );
          }
        }
      })
      .catch((error) => {
        console.error("loadFacilityUnits Error: ", error);
      });
  }, [selectedFacility, editSessionUnitId, editSessionFacilityId, dispatch]);

  useEffect(() => {
    setLoading(true);
    // Fetch all listings for the current filters in a single call and paginate client-side
    getListingsByPersonId(
      filterByPropertyType,
      filterByListingType,
      filterByPropertyName,
      0,
      1000,
    )
      .then((data) => {
        setListings(data);
        setTotalListings(data.length);
        setLoading(false);
      })
      .catch((error) => {
        console.error("getListingsByPersonId Error: ", error);
        setLoading(false);
      });
  }, [filterByPropertyType, filterByListingType, filterByPropertyName]);

  function handleClearFilters() {
    setFilterByPropertyType("");
    setFilterByListingType("");
    setFilterByPropertyName("");
  }

  const filtersActive =
    Boolean(filterByPropertyType) ||
    Boolean(filterByListingType) ||
    Boolean(filterByPropertyName);

  const unitExistsCheckBox = (event) => {
    let checked = event.target.checked;
    setUnitExistsInSystem(checked);
    if (!checked) {
      setSelectedFacility(null);
      setSelectedUnit(null);
      setPropertyName("");
      // Clear all state variables that were populated from unit data
      setPrice("");
      setSqft("");
      setBeds("");
      setBaths("");
      setDescription("");
      setSelectedPropertyType("");
      // Clear property name and other unit-related data from selectedListing as well
      if (selectedListing) {
        let tmp = selectedListing;
        tmp.propertyName = "";
        tmp.unitId = "";
        tmp.price = "";
        tmp.sqft = "";
        tmp.beds = "";
        tmp.baths = "";
        tmp.description = "";
        tmp.propertyTypeCd = "";
        setSelectedListing(tmp);
      }
    }
  };

  const handleSelectedFacilityChanged = (event) => {
    const value = event.target.value;
    setSelectedFacility(value);
    setFacilityUnits([]); // clear units collection to ensure it is updated with facility units once a facility is selected.
    setSelectedUnit(null);
    // Changing facility starts a fresh context; do not carry over the previous session unit.
    setEditSessionUnitId(null);
    setEditSessionFacilityId(null);
    setPropertyName("");
    const facility = userFacilities.find((f) => f.value === value);
    if (facility) {
      setLatitude(facility.latitude);
      setLongitude(facility.longitude);
      setSelectedListing((prev) => ({
        ...prev,
        propertyName: "",
        latitude: facility.latitude,
        longitude: facility.longitude,
      }));
    } else {
      setSelectedListing((prev) => ({ ...prev, propertyName: "" }));
    }
  };

  const handleSelectedUnitChanged = (event) => {
    let value = event.target.value;
    setSelectedUnit(value);
    setSelectedUnitObject(event.target.value);
    let unit = facilityUnits.find((l) => l.value === value);

    // Get the selected facility name
    let selectedFacilityObj = userFacilities.find(
      (f) => f.value === selectedFacility,
    );
    let facilityName = selectedFacilityObj ? selectedFacilityObj.label : "";

    // Set property name as "facility name - unit name"
    let propertyNameValue =
      facilityName && unit
        ? `${facilityName} - ${unit.label}`
        : unit
          ? unit.label
          : "";
    setPropertyName(propertyNameValue);
    setSelectedListing((prev) => ({
      ...prev,
      propertyName: propertyNameValue,
      unitId: value,
      price: unit.rent,
      sqft: unit.sqft,
      beds: unit.beds,
      baths: unit.baths,
      description: unit.description,
      propertyTypeCd: unit.unitTypeCd,
    }));
    setPrice(unit.rent);
    setSqft(unit.sqft);
    setBeds(unit.beds);
    setBaths(unit.baths);
    setDescription(unit.description);
    setSelectedPropertyType(unit.unitTypeCd);
  };

  function handlePropertyTypeChange(event) {
    let value = event.target.value;
    setSelectedPropertyType(value);
    setSelectedListing((prev) => ({ ...prev, propertyTypeCd: value }));
  }

  function handleListingTypeChange(event) {
    let value = event.target.value;
    setSelectedListingType(value);
    setSelectedListing((prev) => ({ ...prev, listingTypeCd: value }));
  }

  function onTextChange(event) {
    const value = event.target.value;
    const id = event.target.id;

    if (id === "propertyName") {
      setPropertyName(value);
      setSelectedListing((prev) => ({ ...prev, propertyName: value }));
    } else if (id === "price") {
      const numericInputPattern = /^\d*\.?\d*$/;
      if (!numericInputPattern.test(value)) {
        return;
      }
      setPrice(value);
      setSelectedListing((prev) => ({ ...prev, price: value }));
    } else if (id === "latitude") {
      setLatitude(value);
      setSelectedListing((prev) => ({ ...prev, latitude: value }));
    } else if (id === "longitude") {
      setLongitude(value);
      setSelectedListing((prev) => ({ ...prev, longitude: value }));
    } else if (id === "squareFeet") {
      setSqft(value);
      setSelectedListing((prev) => ({ ...prev, sqft: value }));
    } else if (id === "beds") {
      setBeds(value);
      setSelectedListing((prev) => ({ ...prev, beds: value }));
    } else if (id === "baths") {
      setBaths(value);
      setSelectedListing((prev) => ({ ...prev, baths: value }));
    } else if (id === "description") {
      setDescription(value);
      setSelectedListing((prev) => ({ ...prev, description: value }));
    }
  }

  // Location picker handler functions
  const handleUseCurrentLocation = () => {
    if (!navigator.geolocation) {
      issueWarnMessage("Geolocation is not supported by your browser.");
      return;
    }

    setIsLoadingLocation(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude.toString();
        const lng = position.coords.longitude.toString();

        setLatitude(lat);
        setLongitude(lng);

        // Update selectedListing if it exists
        setSelectedListing((prev) => ({
          ...prev,
          latitude: lat,
          longitude: lng,
        }));

        setIsLoadingLocation(false);
        issueSuccessMessage(
          "Current location detected and coordinates updated",
        );
      },
      (error) => {
        setIsLoadingLocation(false);
        let errorMessage = "Unable to retrieve your location.";
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = "Location access denied by user.";
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = "Location information is unavailable.";
            break;
          case error.TIMEOUT:
            errorMessage = "Location request timed out.";
            break;
          default:
            errorMessage = "Unable to retrieve your location.";
            break;
        }
        issueWarnMessage(errorMessage);
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 300000, // 5 minutes
      },
    );
  };

  const handleOpenLocationPicker = () => {
    setShowLocationPicker(true);
  };

  const handleLocationConfirm = (lat, lng) => {
    const latStr = lat.toString();
    const lngStr = lng.toString();

    setLatitude(latStr);
    setLongitude(lngStr);

    // Update selectedListing if it exists
    setSelectedListing((prev) => ({
      ...prev,
      latitude: latStr,
      longitude: lngStr,
    }));

    issueSuccessMessage("Location selected and coordinates updated");
  };

  const handleLocationPickerClose = () => {
    setShowLocationPicker(false);
  };

  const syncFilesFromImageItems = (items) => {
    setFiles(items.filter((item) => item.type === "new").map((item) => item.file));
  };

  const createImageItemsFromExisting = (images = []) =>
    images.map((image) => ({
      id: `existing-${image.documentId}`,
      type: "existing",
      documentId: image.documentId,
      fileName: image.fileName,
      systemFileName: image.systemFileName,
    }));

  const handleImageDragEnd = ({ active, over }) => {
    if (!over || active.id === over.id) {
      return;
    }
    setImageOrderItems((prev) => {
      const oldIndex = prev.findIndex((item) => item.id === active.id);
      const newIndex = prev.findIndex((item) => item.id === over.id);
      if (oldIndex < 0 || newIndex < 0) {
        return prev;
      }
      return arrayMove(prev, oldIndex, newIndex);
    });
  };

  const handleFilesChange = (newFiles = []) => {
    setImageOrderItems((prev) => {
      const existingItems = prev.filter((item) => item.type === "existing");
      const newItems = newFiles.map((file, index) => ({
        id: `new-${Date.now()}-${index}-${file.name}`,
        type: "new",
        fileName: file.name,
        file,
      }));
      return [...existingItems, ...newItems];
    });
    setFiles(newFiles);
  };

  const handleRemoveNewImage = (itemId) => {
    setImageOrderItems((prev) => {
      const nextItems = prev.filter((item) => item.id !== itemId);
      syncFilesFromImageItems(nextItems);
      return nextItems;
    });
  };

  const handleAddClicked = () => {
    let data = {
      id: "",
      propertyName: "",
      propertyTypeCd: "",
      listingTypeCd: "",
      price: "",
      latitude: "",
      longitude: "",
      sqft: "",
      beds: "",
      baths: "",
      unitId: "",
      description: "",
      imageFiles: [],
    };
    setTask("Create");
    setListingForm(true);
    setSelectedListing(data);
    setImageOrderItems([]);
    setFiles([]);
    setPendingImageDeletions([]);
    setEditSessionUnitId(null);
    setEditSessionFacilityId(null);
  };

  const handleCancelClicked = () => {
    setPropertyName("");
    setPrice("");
    setLatitude("");
    setLongitude("");
    setSqft("");
    setBeds("");
    setBaths("");
    setDescription("");
    setSelectedListingType("");
    setSelectedPropertyType("");
    setFiles([]);
    setImageOrderItems([]);
    setPendingImageDeletions([]); // Clear pending deletions on cancel
    setListingForm(false);
    setSelectedListing(null);
    setTask("");
    setUnitExistsInSystem(false);
    setSelectedFacility(null);
    setFacilityUnits([]);
    setSelectedUnit(null);
    setEditSessionUnitId(null);
    setEditSessionFacilityId(null);
  };

  const handleSuccessfulFormClose = () => {
    setPropertyName("");
    setPrice("");
    setLatitude("");
    setLongitude("");
    setSqft("");
    setBeds("");
    setBaths("");
    setDescription("");
    setSelectedListingType("");
    setSelectedPropertyType("");
    setFiles([]);
    setImageOrderItems([]);
    // Don't clear pending deletions here - they were already processed
    setListingForm(false);
    setSelectedListing(null);
    setTask("");
    setUnitExistsInSystem(false);
    setSelectedFacility(null);
    setFacilityUnits([]);
    setSelectedUnit(null);
    setEditSessionUnitId(null);
    setEditSessionFacilityId(null);
  };

  const handleCloseView = () => {
    setFiles([]);
    setViewForm(false);
    setSelectedListing(null);
    setTask("");
  };

  const validateFormData = (sendData) => {
    if (
      unitExistsInSystem &&
      (isEmptyString(selectedFacility) || isNullUndefined(selectedFacility))
    ) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Please select facility.",
        }),
      );
      return false;
    }
    if (
      unitExistsInSystem &&
      (isEmptyString(sendData.unitId) || isNullUndefined(sendData.unitId))
    ) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Please select a property unit.",
        }),
      );
      return false;
    }
    if (
      isEmptyString(sendData.propertyName) ||
      isNullUndefined(sendData.propertyName)
    ) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Property name cannot be empty.",
        }),
      );
      return false;
    }

    if (
      isEmptyString(sendData.propertyTypeCd) ||
      isNullUndefined(sendData.propertyTypeCd)
    ) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Please select a property type.",
        }),
      );
      return false;
    }
    if (isEmptyString(sendData.price) || isNullUndefined(sendData.price)) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Price cannot be empty.",
        }),
      );
      return false;
    }
    // Validate price is a strictly numeric value and within range
    const priceString = String(sendData.price).trim();
    const strictPricePattern = /^\d+(\.\d+)?$/;
    if (!strictPricePattern.test(priceString)) {
      dispatch(
        setMessage({
          type: "warning",
          message: "The price sent is not a valid number",
        }),
      );
      return false;
    }
    const priceValue = parseFloat(priceString);
    if (isNaN(priceValue) || priceValue < 0) {
      dispatch(
        setMessage({
          type: "warning",
          message: "The price sent is not a valid number",
        }),
      );
      return false;
    }
    if (priceValue > 10000000000) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Price cannot exceed 10,000,000,000",
        }),
      );
      return false;
    }
    if (
      isEmptyString(sendData.listingTypeCd) ||
      isNullUndefined(sendData.listingTypeCd)
    ) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Please select a listing type.",
        }),
      );
      return false;
    }
    // Latitude is mandatory; validate presence and range
    if (
      isEmptyString(sendData.latitude) ||
      isNullUndefined(sendData.latitude)
    ) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Latitude cannot be empty.",
        }),
      );
      return false;
    } else {
      const latValue = parseFloat(sendData.latitude);
      if (isNaN(latValue) || latValue < -90 || latValue > 90) {
        dispatch(
          setMessage({
            type: "warning",
            message: "Latitude should be valid coordinates.",
          }),
        );
        return false;
      }
      if (sendData.latitude.length > 20) {
        dispatch(
          setMessage({
            type: "warning",
            message: "Latitude cannot exceed 20 characters.",
          }),
        );
        return false;
      }
    }
    // Longitude is mandatory; validate presence and range
    if (
      isEmptyString(sendData.longitude) ||
      isNullUndefined(sendData.longitude)
    ) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Longitude cannot be empty.",
        }),
      );
      return false;
    } else {
      const lngValue = parseFloat(sendData.longitude);
      if (isNaN(lngValue) || lngValue < -180 || lngValue > 180) {
        dispatch(
          setMessage({
            type: "warning",
            message: "Longitude should be valid coordinates.",
          }),
        );
        return false;
      }
      if (sendData.longitude.length > 20) {
        dispatch(
          setMessage({
            type: "warning",
            message: "Longitude cannot exceed 20 characters.",
          }),
        );
        return false;
      }
    }

    // Sqft is optional; validate only if provided
    if (!isEmptyString(sendData.sqft) && !isNullUndefined(sendData.sqft)) {
      const sqftValue = parseFloat(sendData.sqft);
      if (isNaN(sqftValue) || sqftValue < 0) {
        dispatch(
          setMessage({
            type: "warning",
            message: "Size in Square Meters must be a valid positive number.",
          }),
        );
        return false;
      }
    }
    // Check if we have images (either new files or existing images, accounting for pending deletions)
    const hasNewFiles = !isEmptyArray(files);
    const existingImagesCount =
      task === "Edit"
        ? (selectedListing?.imageFiles?.length || 0) -
          pendingImageDeletions.length
        : 0;
    const hasExistingImages = existingImagesCount > 0;
    const hasAnyImages = hasNewFiles || hasExistingImages;

    if (!hasAnyImages) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Please upload at least one image before publishing this listing.",
        }),
      );
      return false;
    }
    // Validate beds is a valid integer (optional field)
    if (!isEmptyString(sendData.beds) && !isNullUndefined(sendData.beds)) {
      const bedsValue = parseInt(sendData.beds);
      if (isNaN(bedsValue) || bedsValue < 0) {
        dispatch(
          setMessage({
            type: "warning",
            message: "Number of beds must be a valid positive integer.",
          }),
        );
        return false;
      }
    }
    // Validate baths is a valid integer (optional field)
    if (!isEmptyString(sendData.baths) && !isNullUndefined(sendData.baths)) {
      const bathsValue = parseInt(sendData.baths);
      if (isNaN(bathsValue) || bathsValue < 0) {
        dispatch(
          setMessage({
            type: "warning",
            message: "Number of baths must be a valid positive integer.",
          }),
        );
        return false;
      }
    }

    return true;
  };

  const handleSubmitClicked = () => {
    let formData = new FormData();

    const orderedActiveItems = imageOrderItems.filter(
      (item) =>
        item.type === "new" ||
        (item.type === "existing" &&
          !pendingImageDeletions.includes(item.documentId)),
    );
    const orderedNewFiles = orderedActiveItems
      .filter((item) => item.type === "new")
      .map((item) => item.file);

    for (const file of orderedNewFiles) {
      //loop through each file in the array and append it in the formData.
      formData.append("listingFiles[]", file);
    }
    formData.append("id", selectedListing.id);
    formData.append("propertyName", selectedListing.propertyName);
    formData.append("propertyTypeCd", selectedListing.propertyTypeCd);
    formData.append("price", selectedListing.price);
    formData.append("listingTypeCd", selectedListing.listingTypeCd);
    // Optional fields: append only when provided
    if (
      !isEmptyString(selectedListing.latitude) &&
      !isNullUndefined(selectedListing.latitude)
    ) {
      formData.append("latitude", selectedListing.latitude);
    }
    if (
      !isEmptyString(selectedListing.longitude) &&
      !isNullUndefined(selectedListing.longitude)
    ) {
      formData.append("longitude", selectedListing.longitude);
    }
    if (
      !isEmptyString(selectedListing.sqft) &&
      !isNullUndefined(selectedListing.sqft)
    ) {
      formData.append("sqft", selectedListing.sqft);
    }
    if (
      !isEmptyString(selectedListing.beds) &&
      !isNullUndefined(selectedListing.beds)
    ) {
      formData.append("beds", selectedListing.beds);
    }
    if (
      !isEmptyString(selectedListing.baths) &&
      !isNullUndefined(selectedListing.baths)
    ) {
      formData.append("baths", selectedListing.baths);
    }
    if (
      !isEmptyString(selectedListing.description) &&
      !isNullUndefined(selectedListing.description)
    ) {
      formData.append("description", selectedListing.description);
    }
    if (
      !isEmptyString(selectedListing.unitId) &&
      !isNullUndefined(selectedListing.unitId)
    ) {
      formData.append("unitId", selectedListing.unitId);
    }
    const orderedExistingIds = orderedActiveItems
      .filter((item) => item.type === "existing")
      .map((item) => item.documentId)
      .filter(Boolean);
    const canSendOrderedIdsWithSave =
      orderedActiveItems.length > 0 &&
      orderedExistingIds.length === orderedActiveItems.length;
    if (canSendOrderedIdsWithSave) {
      formData.append(
        "orderedImageDocumentIds",
        JSON.stringify(orderedExistingIds),
      );
    }

    if (validateFormData(selectedListing)) {
      // First, delete any pending images if in edit mode
      const deletePromises =
        task === "Edit" && pendingImageDeletions.length > 0
          ? pendingImageDeletions.map((documentId) =>
              deleteListingDocument(selectedListing.id, {
                listingId: selectedListing.id,
                documentId: documentId,
              }),
            )
          : [Promise.resolve()];

            Promise.all(deletePromises)
              .then(() => saveListingData(formData))
              .then((saveResponse) => {
                const updatedListing = saveResponse?.listing;
                const activeExistingIds = orderedActiveItems
                  .filter((item) => item.type === "existing")
                  .map((item) => item.documentId);
                const updatedDocumentIds = (updatedListing?.imageFiles || [])
                  .map((image) => image.documentId)
                  .filter(Boolean);
                const newUploadedIds = updatedDocumentIds.filter(
                  (id) => !activeExistingIds.includes(id),
                );
                let newImageCursor = 0;
                const finalOrderedIds = orderedActiveItems
                  .map((item) => {
                    if (item.type === "existing") {
                      return item.documentId;
                    }
                    const nextId = newUploadedIds[newImageCursor];
                    newImageCursor += 1;
                    return nextId;
                  })
                  .filter(Boolean);

                const shouldReorder =
                  updatedListing?.id &&
                  finalOrderedIds.length > 0 &&
                  finalOrderedIds.length === updatedDocumentIds.length;
                const orderChanged =
                  shouldReorder &&
                  finalOrderedIds.some(
                    (documentId, index) =>
                      documentId !== updatedDocumentIds[index],
                  );

                if (orderChanged) {
                  return reorderListingDocuments(
                    updatedListing.id,
                    finalOrderedIds,
                  ).then(() => saveResponse);
                }
                return saveResponse;
              })
              .then((response) => {
                dispatch(
                  setMessage({
                    type: response.type,
                    message: response.message,
                  }),
                );

                // Clear pending deletions after successful save
                setPendingImageDeletions([]);

                // Show draft confirmation modal for new listings
                if (task === "Create") {
                  setDraftConfirmationModal(true);
                } else if (task === "Edit") {
                  handleSuccessfulFormClose();
                } else {
                  handleCancelClicked();
                }

                getListingsByPersonId(
                  filterByPropertyType,
                  filterByListingType,
                  filterByPropertyName,
                  0,
                  1000,
                )
                  .then((data) => {
                    setListings(data);
                    setTotalListings(data.length);
                  })
                  .catch((error) => {
                    console.error("getListingsByPersonId Error: ", error);
                  });
              })
              .catch((error) => console.error("error saving Listing ", error));
        }
    }

  // Add function to handle draft confirmation modal close
  const handleCloseDraftConfirmationModal = () => {
    setDraftConfirmationModal(false);
    handleSuccessfulFormClose();
  };

  // Update the getChipProps function to handle the new status
  function getChipProps(params) {
    if (!isNullUndefined(params.value)) {
      if (params.value === "ACT") {
        return {
          icon: <Check style={{ fill: green[500] }} />,
          label: "Active",
          style: {
            borderColor: green[500],
          },
        };
      } else if (params.value === "INA") {
        return {
          icon: <Pause style={{ fill: amber[500] }} />,
          label: "Inactive",
          style: {
            borderColor: amber[500],
          },
        };
      } else if (params.value === "DRF") {
        return {
          icon: <Edit style={{ fill: amber[500] }} />,
          label: "Draft",
          style: {
            borderColor: amber[500],
          },
        };
      } else if (params.value === "DEL") {
        return {
          icon: <Clear style={{ fill: red[500] }} />,
          label: "Removed",
          style: {
            borderColor: amber[500],
          },
        };
      } else {
        return "N/A";
      }
    }
  }

  const editClicked = (data) => {
    // Remember the unit/facility attached to the listing when Edit is opened
    setEditSessionUnitId(data.unitId || null);
    setEditSessionFacilityId(data.facilityId || null);

    if (!isNullUndefined(data.unitId) && !isEmptyString(data.unitId)) {
      setSelectedFacility(data.facilityId);
      setSelectedUnit(data.unitId);
      setUnitExistsInSystem(true);
    }
    setSelectedListing(data);
    setImageOrderItems(createImageItemsFromExisting(data.imageFiles || []));
    setFiles([]);
    setPendingImageDeletions([]);
    setTask("Edit");
    setListingForm(true);
  };

  const viewClicked = (data) => {
    setSelectedListing(data);
    setTask("View");
    setViewForm(true);
    // Fetch tour bookings when view modal opens
    fetchTourBookings(data.id);
  };

  const deleteListingClicked = (data) => {
    let listingName = data.propertyName;
    setDeleteListingModal(true);
    setSelectedListing(data);
    setTask("Delete");
    let title = "Confirm Delete Listing";
    let body = "Are you sure you want to delete listing " + listingName + "?";
    setTitleText(title);
    setSeverityText("warning");
    setBodyText(body);
    setPositiveText("Delete Listing");
    setNegativeText("Cancel");
  };

  // Replace the separate click handlers with a single toggle handler
  const toggleListingStatusClicked = (data) => {
    const isActive = data.statusCd === "ACT";
    const isDraft = data.statusCd === "DRF";
    
    // Validate that draft listings have images before allowing publish
    if (isDraft) {
      const hasImages = data.imageFiles && Array.isArray(data.imageFiles) && data.imageFiles.length > 0;
      if (!hasImages) {
        dispatch(
          setMessage({
            type: "warning",
            message: "Please upload at least one image before publishing this listing.",
          }),
        );
        return;
      }
    }
    
    setToggleListingModal(true);
    setSelectedListing(data);
    setTask("Toggle");

    let title, body, positiveText;

    if (isActive) {
      title = "Confirm Deactivate Listing";
      body =
        "Deactivating this listing will remove it from public view. You can reactivate it anytime.";
      positiveText = "Deactivate Listing";
    } else if (isDraft) {
      title = "Confirm Publish Listing";
      body = "Publishing this listing will make it available for public view.";
      positiveText = "Publish Listing";
    } else {
      title = "Confirm Activate Listing";
      body = "Activating this listing will make it available for public view.";
      positiveText = "Activate Listing";
    }

    setTitleText(title);
    setSeverityText(isActive ? "warning" : "info");
    setBodyText(body);
    setPositiveText(positiveText);
    setNegativeText("Cancel");
  };

  // Update the positiveAction function
  function positiveAction() {
    if (task === "Delete") {
      handleDeleteListing();
    } else if (task === "Toggle") {
      handleToggleListingStatus();
    }
  }

  // Replace the separate handler functions with a single toggle handler
  function handleToggleListingStatus() {
    if (
      isNullUndefined(selectedListing) ||
      isNullUndefined(selectedListing.id) ||
      isEmptyString(selectedListing.id)
    ) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Could not determine the listing to update.",
        }),
      );
      return;
    }

    let sendData = selectedListing.id;
    toggleListingStatus(sendData)
      .then((response) => {
        dispatch(
          setMessage({
            type: response.type,
            message: response.message,
          }),
        );
        getListingsByPersonId(
          filterByPropertyType,
          filterByListingType,
          filterByPropertyName,
          0,
          1000,
        )
          .then((data) => {
            setListings(data);
            setTotalListings(data.length);
          })
          .catch((error) => {
            console.error("getListingsByPersonId Error: ", error);
          });
        handleCloseToggleListingModal();
      })
      .catch((error) => console.error("error updating listing status", error));
  }

  function handleDeleteListing() {
    if (
      isNullUndefined(selectedListing) ||
      isNullUndefined(selectedListing.id) ||
      isEmptyString(selectedListing.id)
    ) {
      dispatch(
        setMessage({
          type: "warning",
          message: "Could not determine the listing to remove.",
        }),
      );
      return;
    }

    let sendData = selectedListing.id;
    deleteListing(sendData)
      .then((response) => {
        dispatch(
          setMessage({
            type: response.status,
            message: response.message,
          }),
        );
        getListingsByPersonId(
          filterByPropertyType,
          filterByListingType,
          filterByPropertyName,
          0,
          1000,
        )
          .then((data) => {
            setListings(data);
            setTotalListings(data.length);
          })
          .catch((error) => {
            console.error("getListingsByPersonId Error: ", error);
          });
        handleCloseDeleteListingModal();
      })
      .catch((error) => console.error("error deleting listing", error));
  }



  function handleCloseDeleteListingModal() {
    setDeleteListingModal(false);
    setSelectedListing(null);
    setTitleText("");
    setTask("");
    setSeverityText("");
    setBodyText("");
    setPositiveText("");
    setNegativeText("");
  }

  // Replace the separate close handlers with a single close handler
  function handleCloseToggleListingModal() {
    setToggleListingModal(false);
    setSelectedListing(null);
    setTitleText("");
    setTask("");
    setSeverityText("");
    setBodyText("");
    setPositiveText("");
    setNegativeText("");
  }

  const columns = [
    { headerName: "Property Name", field: "propertyName", width: "250" },
    {
      headerName: "Property Type",
      field: "propertyType",
      width: "180",
      valueFormatter: (row) => {
        return row.value.name;
      },
    },
    {
      headerName: "Price",
      field: "price",
      width: "150",
      valueFormatter: (row) => {
        return formatCurrency(row.value);
      },
    },
    {
      headerName: "Listing Type",
      field: "listingType",
      width: "150",
      valueFormatter: (row) => {
        return row.value.name;
      },
    },
    { headerName: "Description", field: "description", width: "300" },
    {
      headerName: "Status",
      field: "statusCd",
      width: "120",
      renderCell: (params) => {
        return (
          <Chip variant="outlined" size="small" {...getChipProps(params)} />
        );
      },
    },
    {
      headerName: "Location",
      field: "plusCode",
      width: "150",
      renderCell: (params) => {
        return params.value ? (
          <a
            target={"_blank"}
            rel="noreferrer"
            title={"View on Map"}
            href={
              "https://www.google.com.sa/maps/search/" +
              encodeURIComponent(params.value) +
              "?hl=en"
            }
          >
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
              }}
            >
              {params.value}
            </div>
          </a>
        ) : (
          "No Location Info"
        );
      },
    },
    {
      headerName: "Actions",
      field: "actions",
      width: "100",
      type: "actions",
      getActions: (params) => {
        let arr = [];
        arr.push(
          <GridActionsCellItem
            icon={<Edit />}
            onClick={() => editClicked(params.row)}
            label="Edit"
            showInMenu
          />,
        );

        arr.push(
          <GridActionsCellItem
            icon={<Visibility />}
            onClick={() => viewClicked(params.row)}
            label="View"
            showInMenu
          />,
        );

        // Add toggle action for ACT, INA, and DRF statuses
        if (
          params.row.statusCd === "ACT" ||
          params.row.statusCd === "INA" ||
          params.row.statusCd === "DRF"
        ) {
          const isActive = params.row.statusCd === "ACT";
          const isDraft = params.row.statusCd === "DRF";

          let actionLabel, actionIcon;
          if (isActive) {
            actionLabel = "Deactivate";
            actionIcon = <Pause />;
          } else if (isDraft) {
            actionLabel = "Publish";
            actionIcon = <PlayArrow />;
          } else {
            actionLabel = "Activate";
            actionIcon = <PlayArrow />;
          }

          arr.push(
            <GridActionsCellItem
              icon={actionIcon}
              onClick={() => toggleListingStatusClicked(params.row)}
              label={actionLabel}
              showInMenu
            />,
          );
        }

        if(["INA", "DRF"].includes(params.row.statusCd)) {
          arr.push(
            <GridActionsCellItem
              icon={<Delete />}
              onClick={() => deleteListingClicked(params.row)}
              label="Delete"
              showInMenu
            />,
          );
        }

        return arr;
      },
    },
  ];

  // Add columns definition for Tour Bookings table
  const tourBookingsColumns = [
    {
      headerName: "Appointment Date",
      field: "appointmentDate",
      width: 180,
      valueFormatter: (row) => {
        const date = new Date(row.value);
        return formatDateTime(date);
      },
    },
    {
      headerName: "Visitor",
      field: "visitorName",
      width: 120,
    },
    {
      headerName: "Email",
      field: "visitorEmail",
      width: 160,
    },
    {
      headerName: "Contact",
      field: "visitorContact",
      width: 120,
    },
    {
      headerName: "Status",
      field: "status",
      width: 120,
      renderCell: (params) => {
        return (
          <Chip
            variant="outlined"
            size="small"
            {...getAppointmentChipProps(params?.row)}
          />
        );
      },
    },
    {
      headerName: "Actions",
      field: "actions",
      width: 120,
      type: "actions",
      getActions: (params) => {
        let arr = [];
        if (params?.row?.status === "Pending") {
          arr.push(
            <GridActionsCellItem
              icon={<Check />}
              onClick={() => handleAppointmentActions(params.row, "approve")}
              label="Approve"
              showInMenu
            />,
          );
          arr.push(
            <GridActionsCellItem
              icon={<CalendarToday />}
              onClick={() => handleAppointmentActions(params.row, "reschedule")}
              label="Reschedule"
              showInMenu
            />,
          );
        }
        arr.push(
          <GridActionsCellItem
            icon={<Clear color="red" />}
            onClick={() => handleAppointmentActions(params.row, "reject")}
            label="Reject"
            showInMenu
          />,
        );

        return arr;
      },
    },
  ];

  // Add function to parse appointments data
  function parseAppointmentsData(data) {
    const newAppointmentsData = [];
    data?.forEach((target) => {
      const appointment = {
        id: target.id,
        appointmentDate: target.appointmentDate,
        visitorName: target?.person?.name,
        visitorEmail: target?.person?.email,
        visitorContact: target?.person?.phone,
        status: target.status,
      };
      newAppointmentsData.push(appointment);
    });
    setAppointments(newAppointmentsData);
  }

  // Add function to fetch tour bookings for a listing
  const fetchTourBookings = (listingId) => {
    if (!listingId) {
      setAppointments([]);
      return;
    }

    setAppointmentsLoading(true);
    listAppointmentsForListing(listingId)
      .then((response) => {
        parseAppointmentsData(response);
      })
      .catch((error) => {
        console.error("Error fetching appointments:", error);
        setAppointments([]);
      })
      .finally(() => {
        setAppointmentsLoading(false);
      });
  };

  // Add function to format date and time
  const formatDateTime = (date) => {
    return new Intl.DateTimeFormat("en-US", {
      weekday: "short",
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(date);
  };

  // Add function to get chip props for appointment status
  function getAppointmentChipProps(row) {
    const status = row.status;
    if (!isNullUndefined(status)) {
      if (status === "Approved") {
        return {
          icon: <Check style={{ fill: green[500] }} />,
          label: status,
          style: {
            borderColor: green[500],
          },
        };
      } else if (status === "Pending") {
        return {
          icon: <Pause style={{ fill: amber[500] }} />,
          label: status,
          style: {
            borderColor: amber[500],
          },
        };
      } else if (status === "Rejected") {
        return {
          icon: <Clear style={{ fill: red[500] }} />,
          label: status,
          style: {
            borderColor: red[500],
          },
        };
      }
    }
    return {
      label: status || "Unknown",
      style: {
        borderColor: amber[500],
      },
    };
  }

  // Add function to handle appointment actions
  function handleAppointmentActions(row, actionType) {
    setAppointmentConfirmType(actionType);
    setSelectedBooking(row);
  }

  // Add function to handle approve/reject appointment
  async function handleApproveOrRejectAppointment() {
    setAppointmentsLoading(true);
    try {
      let response;
      switch (appointmentConfirmType) {
        case "approve":
          response = await processListingAppointment({
            appointmentId: selectedBooking?.id,
            action: "approve",
            reason: appointmentReason,
          });
          setAppointmentReason("");
          break;
        case "reject":
          response = await processListingAppointment({
            appointmentId: selectedBooking?.id,
            action: "reject",
            reason: appointmentReason,
          });
          setAppointmentReason("");
          break;
        case "reschedule":
          const data = {
            rescheduleReason: appointmentReason,
            suggestedTimes: selectedDates,
            appointmentDate: selectedDates.length > 0 ? selectedDates[0] : null,
            appointmentId: selectedBooking?.id,
            listingId: selectedListing?.id,
          };
          response = await saveAppointment(data);
          setSelectedDates([]);
          setAppointmentReason("");
          break;
        default:
          console.warn("Unknown appointment action:", appointmentConfirmType);
          break;
      }

      if (response && response.type && response.message) {
        issueResponseMessage(response);
      }

      // Refresh the appointments list
      if (selectedListing?.id) {
        fetchTourBookings(selectedListing.id);
      }
    } catch (error) {
      console.error("Error processing appointment:", error);
      // Error message is already handled by handleErrorResponse in the service layer
      // No need to dispatch another error message here
    } finally {
      setAppointmentsLoading(false);
      setAppointmentConfirmType("");
      setSelectedBooking(null);
      setAppointmentReason("");
      setSelectedDates([]);
    }
  }

  // Add function to handle deleting listing images
  const handleDeleteImage = (documentId) => {
    if (!documentId) {
      dispatch(
        setMessage({
          type: "warning",
          message:
            "Couldn't determine the document identifier. Try refreshing the page.",
        }),
      );
      return;
    }

    // Add to pending deletions instead of immediately deleting
    setPendingImageDeletions((prev) =>
      prev.includes(documentId) ? prev : [...prev, documentId],
    );

    dispatch(
      setMessage({
        type: "info",
        message:
          "Image marked for deletion. Changes will be saved when you submit the form.",
      }),
    );
  };

  const handleRestoreImage = (documentId) => {
    // Remove from pending deletions
    setPendingImageDeletions((prev) => prev.filter((id) => id !== documentId));

    dispatch(
      setMessage({
        type: "info",
        message: "Image deletion cancelled.",
      }),
    );
  };

  return (
    <ResponsiveRow
      sx={{ flexDirection: "column", width: "100%", alignItems: "center" }}
    >
      <ResponsiveRow sx={{ width: { xs: "100%", lg: "80%" }, margin: "auto" }}>
        <TopBarContainer
          sx={{
            width: { xs: "100%", lg: "80%" },
          }}
          container
        >
          <Grid
            item
            sx={{
              width: { xs: "100%", lg: "70%" },
              textAlign: { xs: "center", lg: "start" },
            }}
          >
            <Typography
              component="div"
              variant="body2"
              sx={{
                display: "block",
                margin: { xs: "5px 0", lg: "0 0 8px 0" },
                fontWeight: 600,
              }}
            >
              Filter by
            </Typography>
            <TextField
              id="searchPropertyType"
              label="Property Type"
              sx={{
                width: { xs: "100%", lg: "25%" },
                margin: { xs: "5px 0", lg: "0 10px 0 0" },
                fontSize: "10px",
                textAlign: { xs: "center", lg: "flex-start" },
              }}
              select
              onChange={(event) => {
                let value = event.target.value;
                setFilterByPropertyType(value);
              }}
              value={filterByPropertyType}
            >
              {propertyTypes && propertyTypes.length > 0 ? (
                propertyTypes.map((propertyType, i) => (
                  <MenuItem key={i} value={propertyType.value}>
                    {propertyType.label}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">No Results Found</MenuItem>
              )}
            </TextField>

            <TextField
              id="searchListingType"
              label="Listing Type"
              sx={{
                width: { xs: "100%", lg: "25%" },
                margin: { xs: "5px 0", lg: "0 10px 0 0" },
                fontSize: "10px",
                textAlign: { xs: "center", lg: "flex-start" },
              }}
              select
              onChange={(event) => {
                let value = event.target.value;
                setFilterByListingType(value);
              }}
              value={filterByListingType}
            >
              {listingTypes && listingTypes.length > 0 ? (
                listingTypes.map((l, i) => (
                  <MenuItem key={i} value={l.value}>
                    {l.label}
                  </MenuItem>
                ))
              ) : (
                <MenuItem value="">No Results Found</MenuItem>
              )}
            </TextField>

            <TextField
              id="searchPropertyName"
              label="Property Name"
              sx={{
                width: { xs: "100%", lg: "25%" },
                margin: { xs: "5px 0", lg: "0 10px 0 0" },
                fontSize: "10px",
              }}
              onChange={(event) => {
                let value = event.target.value;
                setFilterByPropertyName(value);
              }}
              value={filterByPropertyName}
            />
          </Grid>

          <Grid
            sx={{
              width: { xs: "100%", lg: "30%" },
              display: "flex",
              flexDirection: { xs: "column", lg: "row" },
              justifyContent: { xs: "center", lg: "flex-end" },
              alignItems: "stretch",
              gap: { xs: 1, lg: 1 },
            }}
            item
          >
            <TopBarContainedCancelButton
              type="button"
              disabled={!filtersActive}
              onClick={handleClearFilters}
              sx={{ width: { xs: "100%", lg: "200px" }, height: "50px" }}
            >
              Clear Filters
            </TopBarContainedCancelButton>
            <TopBarContainedBrandButton
              type="button"
              onClick={handleAddClicked}
              sx={{ width: { xs: "100%", lg: "200px" }, height: "50px" }}
            >
              Add New Listing
            </TopBarContainedBrandButton>
          </Grid>
        </TopBarContainer>
      </ResponsiveRow>
      <br />

      <ResponsiveRow
        sx={{ width: { xs: "100%", lg: "90%", xl: "80%" }, margin: "auto" }}
      >
        <MuiDataGrid
            noSelection={true}
            dataGridColumns={columns}
            dataGridRows={listings}
            serverPagination={true}
            loading={loading}
            height="60vh"
            totalRows={listings.length}
            noBoxShadow={false}
        />
      </ResponsiveRow>
      {listingForm && (task === "Create" || task === "Edit") && (
        <ModalContainerModule
          size="md"
          accept={handleSubmitClicked}
          cancel={handleCancelClicked}
          openModal={listingForm}
          modalTitle="Listing Details"
          acceptButtonText={task === "Create" ? "Save" : "Update"}
        >
          {/*<ModalInnerContainer>*/}
          <Paper
            // variant="outlined"
            sx={{
              height: "auto",
              margin: "auto",
              padding: "20px",
              textAlign: "left",
              border: 0,
              boxShadow: "none",
            }}
          >
            <Paper
              //   variant="outlined"
              sx={{
                height: "auto",
                margin: "auto",
                padding: "10px",
                textAlign: "left",
                boxShadow: "none",
              }}
            >
              <ResponsiveRow container>
                {userHasAdminRole && (
                  <Grid
                    item
                    sx={{
                      width: { xs: "100%", lg: "33.3%" },
                      marginBottom: "10px",
                    }}
                  >
                    <FormGroup>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={unitExistsInSystem}
                            onChange={(event) => unitExistsCheckBox(event)}
                          />
                        }
                        label="Does the Unit/Property exist in the system?"
                      />
                    </FormGroup>
                  </Grid>
                )}
                {unitExistsInSystem && (
                  <Grid
                    item
                    sx={{
                      width: { xs: "100%", lg: "33.3%" },
                      marginBottom: "10px",
                    }}
                  >
                    <TextField
                      variant="outlined"
                      sx={{
                        width: "90%",
                        backgroundColor: "#efefef",
                        borderRadius: "10px",
                      }}
                      label="Select Facility"
                      id={"facility"}
                      select
                      onChange={(event) => handleSelectedFacilityChanged(event)}
                      value={selectedFacility || ""}
                    >
                      {userFacilities && userFacilities.length > 0 ? (
                        userFacilities.map((facility, i) => (
                          <MenuItem
                            key={i}
                            value={facility.value}
                            label={facility.label}
                          >
                            {facility.label}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="">No Results Found</MenuItem>
                      )}
                    </TextField>
                  </Grid>
                )}

                {selectedFacility && unitExistsInSystem && (
                  <Grid
                    item
                    sx={{
                      width: { xs: "100%", lg: "33.3%" },
                      marginBottom: "10px",
                    }}
                  >
                    <TextField
                      variant="outlined"
                      sx={{
                        width: "90%",
                        backgroundColor: "#efefef",
                        borderRadius: "10px",
                      }}
                      label="Select Unit"
                      id={"unit"}
                      select
                      onChange={(event) => handleSelectedUnitChanged(event)}
                      value={selectedUnit || ""}
                    >
                      {facilityUnits && facilityUnits.length > 0 ? (
                        facilityUnits.map((unit, i) => (
                          <MenuItem
                            key={i}
                            value={unit.value}
                            label={unit.label}
                          >
                            {unit.label}
                          </MenuItem>
                        ))
                      ) : (
                        <MenuItem value="">No Results Found</MenuItem>
                      )}
                    </TextField>
                  </Grid>
                )}

                <Grid
                  item
                  sx={{
                    width: { xs: "100%", lg: "33.3%" },
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    variant="outlined"
                    sx={{
                      width: "90%",
                      backgroundColor: "#efefef",
                      borderRadius: "10px",
                    }}
                    label="Property Name"
                    id={"propertyName"}
                    onChange={(event) => onTextChange(event)}
                    value={
                      selectedListing
                        ? (selectedListing.propertyName ?? "")
                        : (propertyName ?? "")
                    }
                    required={true}
                  />
                </Grid>

                <Grid
                  item
                  sx={{
                    width: { xs: "100%", lg: "33.3%" },
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    variant="outlined"
                    sx={{
                      width: "90%",
                      backgroundColor: "#efefef",
                      borderRadius: "10px",
                    }}
                    label="Property Type"
                    id={"propertyType"}
                    select
                    onChange={(event) => handlePropertyTypeChange(event)}
                    value={(() => {
                      const val = selectedListing
                        ? (selectedListing.propertyTypeCd ?? "")
                        : (selectedPropertyType ?? "");
                      const exists =
                        propertyTypes &&
                        propertyTypes.some((pt) => pt.value === val);
                      return exists ? val : "";
                    })()}
                    required={true}
                  >
                    {propertyTypes && propertyTypes.length > 0 ? (
                      propertyTypes.map((propertyType, i) => (
                        <MenuItem
                          key={i}
                          value={propertyType.value}
                          label={propertyType.label}
                        >
                          {propertyType.label}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">No Results Found</MenuItem>
                    )}
                  </TextField>
                </Grid>

                <Grid
                  item
                  sx={{
                    width: { xs: "100%", lg: "33.3%" },
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    variant="outlined"
                    sx={{
                      width: "90%",
                      backgroundColor: "#efefef",
                      borderRadius: "10px",
                    }}
                    label="Price"
                    id={"price"}
                    type="number"
                    inputProps={{ min: 0, max: 10000000000, step: "0.01" }}
                    onChange={(event) => onTextChange(event)}
                    value={
                      selectedListing
                        ? (selectedListing.price ?? "")
                        : (price ?? "")
                    }
                    required={true}
                  />
                </Grid>
                <Grid
                  item
                  sx={{
                    width: { xs: "100%", lg: "33.3%" },
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    variant="outlined"
                    sx={{
                      width: "90%",
                      backgroundColor: "#efefef",
                      borderRadius: "10px",
                    }}
                    label="Listing Type"
                    id={"listingType"}
                    select
                    onChange={(event) => handleListingTypeChange(event)}
                    value={(() => {
                      const val = selectedListing
                        ? (selectedListing.listingTypeCd ?? "")
                        : (selectedListingType ?? "");
                      const exists =
                        listingTypes &&
                        listingTypes.some((lt) => lt.value === val);
                      return exists ? val : "";
                    })()}
                    required={true}
                  >
                    {listingTypes && listingTypes.length > 0 ? (
                      listingTypes.map((l, i) => (
                        <MenuItem key={i} value={l.value} label={l.label}>
                          {l.label}
                        </MenuItem>
                      ))
                    ) : (
                      <MenuItem value="">No Results Found</MenuItem>
                    )}
                  </TextField>
                </Grid>

                {/* Latitude + Longitude + Location Buttons (one responsive row) */}
                <Grid
                  container
                  spacing={2}
                  sx={{ width: "100%", marginBottom: "10px" }}
                >
                  <Grid
                    item
                    sx={{
                      width: { xs: "100%", lg: "33.3%" },
                      marginBottom: "10px",
                    }}
                  >
                    <TextField
                      variant="outlined"
                      sx={{
                        width: "95%",
                        backgroundColor: "#efefef",
                        borderRadius: "10px",
                      }}
                      label="Latitude"
                      id={"latitude"}
                      onChange={(event) => onTextChange(event)}
                      value={
                        selectedListing
                          ? (selectedListing.latitude ?? "")
                          : (latitude ?? "")
                      }
                      required={true}
                      fullWidth
                    />
                  </Grid>

                  <Grid
                    item
                    sx={{
                      width: { xs: "100%", lg: "33.3%" },
                      marginBottom: "10px",
                    }}
                  >
                    <TextField
                      variant="outlined"
                      sx={{
                        width: "95%",
                        backgroundColor: "#efefef",
                        borderRadius: "10px",
                      }}
                      label="Longitude"
                      id={"longitude"}
                      onChange={(event) => onTextChange(event)}
                      value={
                        selectedListing
                          ? (selectedListing.longitude ?? "")
                          : (longitude ?? "")
                      }
                      required={true}
                      fullWidth
                    />
                  </Grid>

                  <Grid 
                    item
                    sx={{
                      width: { xs: "100%", lg: "33.3%" },
                      marginBottom: "10px",
                    }}
                  >
                    <Grid container spacing={1.5} sx={{ width: "100%" }}>
                      <Grid item xs={12} xl={6}>
                        <Button
                          fullWidth
                          variant="outlined"
                          startIcon={
                            isLoadingLocation ? (
                              <CircularProgress size={16} />
                            ) : (
                              <LocationOn />
                            )
                          }
                          onClick={handleUseCurrentLocation}
                          disabled={isLoadingLocation}
                          sx={{
                            minWidth: { xs: "100%", xl: 150 },
                            borderColor: "#037171",
                            color: "#037171",
                            whiteSpace: "nowrap",
                            "&:hover": {
                              borderColor: "#2d9f93",
                              backgroundColor: "#f0f9f8",
                            },
                          }}
                        >
                          {isLoadingLocation
                            ? "Getting Location..."
                            : "My Location"}
                        </Button>
                      </Grid>

                      <Grid item xs={12} xl={6}>
                        <Button
                          fullWidth
                          variant="outlined"
                          startIcon={<Map />}
                          onClick={handleOpenLocationPicker}
                          sx={{
                            minWidth: { xs: "100%", xl: 150 },
                            borderColor: "#037171",
                            color: "#037171",
                            whiteSpace: "nowrap",
                            "&:hover": {
                              borderColor: "#2d9f93",
                              backgroundColor: "#f0f9f8",
                            },
                          }}
                        >
                          Pick on Map
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  item
                  sx={{
                    width: { xs: "100%", lg: "33.3%" },
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    variant="outlined"
                    sx={{
                      width: "90%",
                      backgroundColor: "#efefef",
                      borderRadius: "10px",
                    }}
                    label="Square Meters"
                    id={"squareFeet"}
                    onChange={(event) => onTextChange(event)}
                    value={
                      selectedListing
                        ? (selectedListing.sqft ?? "")
                        : (sqft ?? "")
                    }
                  />
                </Grid>

                <Grid
                  item
                  sx={{
                    width: { xs: "100%", lg: "33.3%" },
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    variant="outlined"
                    sx={{
                      width: "90%",
                      backgroundColor: "#efefef",
                      borderRadius: "10px",
                    }}
                    label="Beds"
                    id={"beds"}
                    onChange={(event) => onTextChange(event)}
                    value={
                      selectedListing
                        ? (selectedListing.beds ?? "")
                        : (beds ?? "")
                    }
                  />
                </Grid>

                <Grid
                  item
                  sx={{
                    width: { xs: "100%", lg: "33.3%" },
                    marginBottom: "10px",
                  }}
                >
                  <TextField
                    variant="outlined"
                    sx={{
                      width: "90%",
                      backgroundColor: "#efefef",
                      borderRadius: "10px",
                    }}
                    label="Baths"
                    id={"baths"}
                    onChange={(event) => onTextChange(event)}
                    value={
                      selectedListing
                        ? (selectedListing.baths ?? "")
                        : (baths ?? "")
                    }
                  />
                </Grid>

                <Grid
                  item
                  sx={{
                    width: { xs: "100%", lg: "55%" },
                    marginBottom: "10px",
                  }}
                >
                  <InputCharactersCountWrapper
                    value={selectedListing?.description ?? description ?? ""}
                    maxLength={380}
                    width={{ xs: "100%", md: "90%" }}
                  >
                    <TextField
                      variant="outlined"
                      sx={{
                        width: "100%",
                        backgroundColor: "#efefef",
                        borderRadius: "10px",
                      }}
                      label="Description"
                      id={"description"}
                      multiline
                      rows={4}
                      onChange={(event) => onTextChange(event)}
                      value={
                        selectedListing
                          ? (selectedListing.description ?? "")
                          : (description ?? "")
                      }
                    />
                  </InputCharactersCountWrapper>
                </Grid>

                {/* Display existing images and newly added files */}
                {(imageOrderItems?.length > 0) && (
                  <Grid
                    item
                    sx={{
                      width: { xs: "100%", lg: "97%" },
                      marginBottom: "10px",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{ mb: 1, fontWeight: 600 }}
                    >
                      Images (
                      {imageOrderItems.filter(
                        (item) =>
                          item.type === "new" ||
                          (item.type === "existing" &&
                            !pendingImageDeletions.includes(item.documentId)),
                      ).length}
                      ) - Drag to reorder
                    </Typography>
                    <DndContext
                      sensors={sensors}
                      collisionDetection={closestCenter}
                      onDragEnd={handleImageDragEnd}
                    >
                      <SortableContext
                        items={imageOrderItems.map((item) => item.id)}
                        strategy={rectSortingStrategy}
                      >
                        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, mb: 2 }}>
                          {imageOrderItems.map((item) => (
                            <SortableImageItem
                              key={item.id}
                              item={item}
                              isPendingDeletion={
                                item.type === "existing" &&
                                pendingImageDeletions.includes(item.documentId)
                              }
                              onDelete={handleDeleteImage}
                              onRestore={handleRestoreImage}
                              onRemoveNew={handleRemoveNewImage}
                            />
                          ))}
                        </Box>
                      </SortableContext>
                    </DndContext>
                  </Grid>
                )}

                <Grid
                  item
                  sx={{
                    width: { xs: "100%", lg: "97%" },
                    marginBottom: "10px",
                  }}
                >
                  <FileUpload
                    value={files}
                    onChange={handleFilesChange}
                    accept={imageTypes}
                    multiple={true}
                    maxSize={5242880}
                    title="Drop image files here or click to browse"
                    buttonText="Choose Listing Images"
                    maxFiles={10}
                  />
                </Grid>
              </ResponsiveRow>
            </Paper>
          </Paper>
          {/*</ModalInnerContainer>*/}
        </ModalContainerModule>
      )}

      {task === "View" && (
        <ModalContainerModule
          size="md"
          openModal={viewForm}
          modalTitle={"Listing Details"}
          cancel={handleCloseView}
        >
          <ResponsiveRow container>
            {/* Left Column - Property Details + Tour Bookings */}
            <Box
                sx={{
                  width: { lg: "60.6%", md: "100%", xs: "100%" },
                  display: "flex",
                  flexDirection: "column",
                }}
            >
              {/* Property Details - First 2 columns */}
              <Box
                  sx={{
                    display: "flex",
                    flexDirection: {xs: "column", sm: "row"},
                    gap: {xs: "0px", sm: "20px"},
                    marginBottom: "20px",
                  }}
              >
                <DetailsColumn
                    sx={{
                      width: {xs: "auto", sm: "50%"},
                    }}
                >
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      Property Name:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {selectedListing && selectedListing.propertyName}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      Listing Type:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {(selectedListing &&
                              selectedListing.listingTypeCd &&
                              listingTypes.find(
                                  (lt) =>
                                      lt.value === selectedListing.listingTypeCd,
                              )?.label) ||
                          selectedListing.listingTypeCd}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      SqM:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {selectedListing
                          ? formatCurrency(selectedListing.sqft)
                          : ""}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      Longitude:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {selectedListing && selectedListing.longitude}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      Description:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {selectedListing && selectedListing.description}
                    </DetailsText>
                  </DetailsRow>
                </DetailsColumn>
                <DetailsColumn
                    sx={{
                      width: {xs: "auto", sm: "50%"},
                    }}
                >
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      Property Type:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {(selectedListing &&
                              selectedListing.propertyTypeCd &&
                              propertyTypes.find(
                                  (pt) =>
                                      pt.value === selectedListing.propertyTypeCd,
                              )?.label) ||
                          selectedListing.propertyTypeCd}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      Beds:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {selectedListing && selectedListing.beds}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      Baths:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {selectedListing && selectedListing.baths}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      Latitude:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {selectedListing && selectedListing.latitude}
                    </DetailsText>
                  </DetailsRow>
                  <DetailsRow>
                    <DetailsLabel
                        sx={{ minWidth: "auto", marginRight: "10px" }}
                    >
                      Price:
                    </DetailsLabel>
                    <DetailsText sx={{ paddingLeft: "5px" }}>
                      {selectedListing
                          ? formatCurrency(selectedListing.price)
                          : ""}
                    </DetailsText>
                  </DetailsRow>
                </DetailsColumn>
              </Box>

              {/* Tour Bookings Grid */}
              <Box
                  sx={{
                    width: "100%",
                    maxHeight: "300px",
                    overflow: "auto",
                  }}
              >
                <Typography variant="h5" sx={{ marginBlock: "10px" }}>
                  Tour Bookings
                </Typography>
                <MuiDataGrid
                    noSelection={true}
                    dataGridColumns={tourBookingsColumns}
                    dataGridRows={appointments}
                    serverPagination={false}
                    loading={appointmentsLoading}
                    height="300px"
                    totalRows={appointments.length}
                />
              </Box>
            </Box>

            {/* Right Column - Documents */}
            <DetailsColumn
                sx={{
                  width: { lg: "33.3%", md: "100%", xs: "100%" },
                }}
            >
              {selectedListing && (
                  <DocumentStore
                      files={[
                        ...selectedListing.imageFiles,
                        ...selectedListing.otherDocuments,
                      ]}
                      item={selectedListing}
                      type={"Listing"}
                      height="500px"
                  />
              )}
            </DetailsColumn>
          </ResponsiveRow>
        </ModalContainerModule>
      )}

      <ConfirmationModal
        showConfirmationModal={deleteListingModal}
        handleConfirmationClose={handleCloseDeleteListingModal}
        title={titleText}
        severity={severityText}
        body={bodyText}
        positiveText={positiveText}
        negativeText={negativeText}
        positiveAction={positiveAction}
        negativeAction={handleCloseDeleteListingModal}
      />

      <ConfirmationModal
        showConfirmationModal={toggleListingModal}
        handleConfirmationClose={handleCloseToggleListingModal}
        title={titleText}
        severity={severityText}
        body={bodyText}
        positiveText={positiveText}
        negativeText={negativeText}
        positiveAction={positiveAction}
        negativeAction={handleCloseToggleListingModal}
      />

      <ConfirmationModal
        showConfirmationModal={draftConfirmationModal}
        handleConfirmationClose={handleCloseDraftConfirmationModal}
        title="Listing Saved as Draft"
        severity="info"
        body="Your listing has been saved as a draft. It will be published once you publish it."
        positiveText="OK"
        negativeText="Cancel"
        positiveAction={handleCloseDraftConfirmationModal}
        negativeAction={handleCloseDraftConfirmationModal}
      />

      {/* Appointment Action Confirmation Modal */}
      {appointmentConfirmType && (
        <ConfirmationModal
          showConfirmationModal={appointmentConfirmType}
          positiveAction={handleApproveOrRejectAppointment}
          negativeAction={() => {
            setAppointmentConfirmType("");
            setSelectedBooking(null);
            setAppointmentReason("");
            setSelectedDates([]);
          }}
          severity={
            appointmentConfirmType === "reject"
              ? "error"
              : appointmentConfirmType === "approve"
                ? "success"
                : "info"
          }
          title={`${titleCase(appointmentConfirmType)} Booking`}
          body={
            "Are you sure you want to " +
            appointmentConfirmType +
            " this booking?"
          }
          additionalContent={
            <Box sx={{ width: "100%", mt: 2 }}>
              {(appointmentConfirmType === "approve" ||
                appointmentConfirmType === "reject" ||
                appointmentConfirmType === "reschedule") && (
                <>
                  <Typography sx={{ mb: 1 }}>
                    Reason{" "}
                    {appointmentConfirmType === "reschedule" && (
                      <span style={{ color: "red" }}>*</span>
                    )}
                  </Typography>
                  <OutlinedInput
                    autoFocus={true}
                    multiline={true}
                    rows={2}
                    value={appointmentReason}
                    onChange={(e) => setAppointmentReason(e.target.value)}
                    placeholder={
                      appointmentConfirmType === "reschedule"
                        ? "Reschedule reason is required..."
                        : `Add a reason why to ${appointmentConfirmType} this booking...`
                    }
                    sx={{ marginBottom: "10px", width: "100%" }}
                    required={appointmentConfirmType === "reschedule"}
                  />
                </>
              )}

              {appointmentConfirmType === "reschedule" && (
                <SuggestedDatesSelector
                  selectedDates={selectedDates}
                  setSelectedDates={setSelectedDates}
                  isOwnBooking={selectedBooking?.isOwner}
                />
              )}
            </Box>
          }
          positiveText={`${titleCase(appointmentConfirmType)}`}
          negativeText="Cancel"
        />
      )}

      {/* Location Picker Modal */}
      <LocationPickerModal
        open={showLocationPicker}
        onClose={handleLocationPickerClose}
        onConfirm={handleLocationConfirm}
        initialLocation={
          selectedListing &&
          selectedListing.latitude &&
          selectedListing.longitude
            ? {
                lat: parseFloat(selectedListing.latitude),
                lng: parseFloat(selectedListing.longitude),
              }
            : null
        }
      />
    </ResponsiveRow>
  );
}
